/**
 * Plotly.js setup for MyLojic portal.
 * v3.36 - 2026-02-23 - Fix TS2348: use factory module for custom Plotly bundle wiring.
 * v3.34 - 2026-02-23 - Story 3: Plotly dependencies & setup (ADR-002)
 *
 * Uses plotly.js-dist-min (full Plotly, minified ~3.5MB) because the
 * visualization knowledge maps require trace types spanning all Plotly
 * bundles: indicator, waterfall, funnel, treemap, heatmap, etc.
 *
 * react-plotly.js factory module wires a custom Plotly bundle to a React component.
 * Import Plot from this file everywhere — never import react-plotly.js directly.
 */
import Plotly from 'plotly.js-dist-min';
// eslint-disable-next-line @typescript-eslint/no-var-requires
import createPlotlyComponent from 'react-plotly.js/factory';

export const Plot = createPlotlyComponent(Plotly);
export type { PlotParams } from 'react-plotly.js';
